import { useEffect, useState } from 'react';
import { useParams } from 'react-router';
import { InlineError, Skeleton } from '../../components/ui';
import { createPublicSupabaseClient, type SupabaseClient } from '../../lib/supabase';
import { PagePulseView } from './PagePulseView';
import { PulseError, loadPulse, pulseErrorMessage, type PulsePayload } from './pagePulseApi';
export function PagePulsePortalPage({ client: suppliedClient }: { client?: SupabaseClient } = {}) {
  const [client] = useState(() => suppliedClient ?? createPublicSupabaseClient());
  const { token } = useParams<{ token: string }>();
  const [days, setDays] = useState<7 | 28 | 90>(28);
  const [payload, setPayload] = useState<PulsePayload | null>(null);
  const [error, setError] = useState<string | null>(null);
  useEffect(() => {
    const root = document.documentElement;
    const previous = root.dataset.theme;
    root.dataset.theme = 'ocean';
    return () => {
      if (previous === undefined) delete root.dataset.theme;
      else root.dataset.theme = previous;
    };
  }, []);
  useEffect(() => {
    if (token === undefined || token === '') {
      setError(pulseErrorMessage('bad_request'));
      return;
    }
    void loadPulse(client, token, days)
      .then((next) => {
        setPayload(next);
        setError(null);
      })
      .catch((cause: unknown) =>
        setError(pulseErrorMessage(cause instanceof PulseError ? cause.code : 'unreachable')),
      );
  }, [client, token, days]);
  return (
    <main className="page-pulse-portal">
      {error !== null ? (
        <InlineError>{error}</InlineError>
      ) : payload === null ? (
        <Skeleton lines={8} label="Loading Page Pulse" />
      ) : (
        <>
          <PagePulseView payload={payload} days={days} onDays={setDays} mode="share" />
          <p>This is a private link. It can be switched off at any time.</p>
        </>
      )}
    </main>
  );
}
